export default "__VITE_ASSET__Cr6P8Cb___"